<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.includeType"
        placeholder="出现类型"
      >
        <el-option
          v-for="(item, i) in classTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.includeUserName"
        placeholder="视频人物姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="视频名称/主讲人"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      classTypeData: [],
    };
  },
  created() {
    this.getSysParamByTypes([
      "VIDEO_INCLUDE_INFO_TYPE",
    ]);
  },
  methods: {
    trainTypeChange(val) {
      console.log(val);
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["VIDEO_INCLUDE_INFO_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.classTypeData = res.data["VIDEO_INCLUDE_INFO_TYPE"];
      });
    },
    initData() {
      let params = {
        ...this.filters,
        t: new Date().getTime(),
      };
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
.width-adapt {
  width: 135px;
}
/deep/ .el-cascader .el-input .el-input__inner {
  background: #edf2f9;
}
.w-160 {
  width: 160px;
}

/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 120px;
}

</style>
